import { Injectable } from '@angular/core';
import { ApiErrorHandler } from './models/api-error-handler';
import { DefaultAjaxErrorHandlerService } from './default-ajax-error-handler.service';
import { DefaultApplicationErrorHandlerService } from './default-application-error-handler.service';

@Injectable()
export class DefaultApiErrorHandlerService implements ApiErrorHandler {
  constructor(
    public ajaxErrorHandler: DefaultAjaxErrorHandlerService,
    public applicationErrorHandler: DefaultApplicationErrorHandlerService
  ) {}
}
